<app-header></app-header>
<div class="main-container d-flex">
  <app-sidebar></app-sidebar>
  <div class="container-fluid h-100p overflow-y-scroll osint-number-main wc-main">
    <div class="top-section">
      <div class="nav-actions-row wc-nav-actions-row">
        <div class="credits-display">
          <div class="credits-inline">
            <span class="credits-inline-label">Remaining:</span>
            <span class="credits-inline-value"><i class="fas fa-spinner fa-spin" *ngIf="creditsLoading" aria-hidden="true"></i><ng-container *ngIf="!creditsLoading">{{ availableCredits | creditsLabel }}</ng-container></span>
          </div>
          <button class="buy-credits-btn" (click)="onBuyCreditsButtonClick()">
            <i class="fas fa-coins credits-icon"></i>
            Buy Credits
          </button>
        </div>
      </div>

      <div class="search-card-container" *ngIf="isServiceDisabled">
        <div class="service-disabled-warning">
          <div class="warning-icon"><i class="fas fa-exclamation-triangle"></i></div>
          <h2 class="warning-title">Search temporarily unavailable</h2>
          <p class="warning-message">
            We're experiencing a temporary service issue. You can still access your previous capture history below.
          </p>
        </div>
      </div>

      <div class="search-card-container" *ngIf="!isServiceDisabled">
        <div class="search-card">
          <h2 class="search-title">Capture URL</h2>
          <p class="credit-cost-notice credit-cost-notice-number px-2" *ngIf="searchCreditCost != null">
            Each capture costs <strong>{{ searchCreditCost }}</strong>
            {{ searchCreditCost === 1 ? 'credit' : 'credits' }}. Credits are deducted on successful capture.
          </p>

          <div class="restricted-alert" appRestrictedAccessWarning>
            <i class="fas fa-exclamation-circle alert-icon"></i>
            <span class="alert-restricted">RESTRICTED ACCESS!</span>
            <span class="alert-authorized">Authorized Law Enforcement Use Only</span>
          </div>

          <div class="wc-search-panel">
            <div class="search-input-container">
              <div class="phone-input-group wc-url-input-group">
                <i class="fas fa-globe wc-url-input-icon" aria-hidden="true"></i>
                <input
                  type="text"
                  class="phone-input wc-url-input"
                  placeholder="Enter a suspicious URL, e.g. https://secure-login-verify.example"
                  [(ngModel)]="captureUrl"
                  (keydown.enter)="startCapture()"
                  [disabled]="isCapturing"
                />
                <button
                  type="button"
                  class="search-button"
                  (click)="startCapture()"
                  [disabled]="isCapturing"
                >
                  <i class="fas" [ngClass]="loadingJobIds ? 'fa-spinner fa-spin' : 'fa-search'"></i>
                  {{ loadingJobIds ? 'Capturing' : 'Capture' }}
                </button>
              </div>
            </div>
          </div>

          <div class="wc-options-block" [class.is-disabled]="isCapturing">
            <div class="wc-option-box">
              <div class="wc-option-box-row">
                <div class="wc-option-box-main">
                  <i class="fas fa-layer-group wc-option-icon" aria-hidden="true"></i>
                  <div class="wc-option-content">
                    <div class="wc-option-title-row">
                      <span class="wc-option-label">Crawl &amp; mirror entire site</span>
                      <span class="wc-badge">Full mirror</span>
                    </div>
                    <p class="wc-option-desc">
                      Follow internal links and preserve every reachable page, not just the entry URL.
                    </p>
                  </div>
                </div>
                <div class="wc-option-controls">
                  <select
                    *ngIf="enableCrawl"
                    class="wc-page-select"
                    [(ngModel)]="crawlMaxPages"
                    [disabled]="isCapturing"
                  >
                    <option *ngFor="let opt of crawlPageOptions" [ngValue]="opt.value">
                      Up to {{ opt.value }} pages
                    </option>
                  </select>
                  <label class="wc-switch">
                    <input
                      type="checkbox"
                      [(ngModel)]="enableCrawl"
                      [disabled]="isCapturing"
                    />
                    <span class="wc-switch-slider"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="wc-option-box">
              <div class="wc-option-box-main wc-option-box-stacked">
                <i class="fas fa-tags wc-option-icon" aria-hidden="true"></i>
                <div class="wc-option-content">
                  <span class="wc-option-label">Keyword watchlist</span>
                  <p class="wc-option-desc">
                    Optional. Comma-separated terms (brand names, victim names, IBANs, etc.) to flag wherever they appear across captured pages.
                  </p>
                  <input
                    type="text"
                    class="wc-keywords-input"
                    placeholder="e.g. paypal, verify account, +1-202, bank of"
                    [(ngModel)]="keywords"
                    [disabled]="isCapturing"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="wc-progress-panel wc-progress-enter" *ngIf="loadingJobIds">
            <div class="wc-progress-header">
              <i class="bi bi-shield-check"></i>
              Acquiring evidence — please keep this page open
            </div>
            <div class="wc-progress-grid">
              <div
                class="wc-progress-step"
                *ngFor="let step of captureSteps; let i = index"
                [class.is-active]="i === activeCaptureStep"
                [class.is-done]="i < activeCaptureStep"
                [class.is-pending]="i > activeCaptureStep"
              >
                <i
                  class="fas wc-progress-step-icon"
                  [ngClass]="i === activeCaptureStep ? 'fa-spinner fa-spin' : step.icon"
                ></i>
                <span class="wc-progress-step-label">{{ step.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="loading-container" *ngIf="searchLoading || (loadingRecentResults && !loadingJobIds)">
        <div class="spinner-border" role="status"></div>
        <p class="loading-text">Fetching results, please wait...</p>
      </div>

      <div class="results-section">
        <div class="card-body p-2 p-md-4">
          <div class="results-topbar">
            <div class="results-header">
              <h3 class="results-title">Recent Web Captures</h3>
              <p class="results-subtitle">Click any row to open the forensic report.</p>
            </div>
            <div class="results-controls">
              <div class="filter-section">
                <select class="filter-select" [(ngModel)]="selectedFilterType" (ngModelChange)="onFilterTypeChange()">
                  <option *ngFor="let ft of filterTypes" [value]="ft.value">{{ ft.label }}</option>
                </select>
                <div class="filter-input-container">
                  <input *ngIf="selectedFilterType === 'url'" class="filter-input" type="text" placeholder="Search by URL" [(ngModel)]="urlFilter" (ngModelChange)="onFilterTypeChange()" />
                  <input *ngIf="selectedFilterType === 'notes'" class="filter-input" type="text" placeholder="Search by notes" [(ngModel)]="notesFilter" (ngModelChange)="onFilterTypeChange()" />
                  <div class="date-filter-group" *ngIf="selectedFilterType === 'date-added'">
                    <input class="filter-input date-input" type="date" [(ngModel)]="startDateFilter" (ngModelChange)="onFilterTypeChange()" />
                    <input class="filter-input date-input" type="date" [(ngModel)]="endDateFilter" (ngModelChange)="onFilterTypeChange()" />
                  </div>
                </div>
              </div>
              <div class="action-buttons">
                <button class="action-btn delete-btn" (click)="onDeleteButtonClick()">
                  <i class="fas fa-trash"></i> Delete
                </button>
              </div>
            </div>
          </div>

          <div class="results-table-container">
            <table class="results-table">
              <colgroup>
                <col class="col-checkbox">
                <col class="col-url">
                <col class="col-domain">
                <col class="col-status">
                <col class="col-date">
                <col class="col-notes">
              </colgroup>
              <thead>
                <tr>
                  <th class="checkbox-column"></th>
                  <th>URL</th>
                  <th>Domain</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of recentResultsPaged" (click)="openResult(row)" class="table-row clickable-row">
                  <td class="checkbox-column" (click)="$event.stopPropagation()">
                    <input type="checkbox" class="table-checkbox" [(ngModel)]="row.isSelected" />
                  </td>
                  <td class="url-column text-truncate">{{ row.url }}</td>
                  <td class="domain-column">{{ row.domain || '—' }}</td>
                  <td class="status-column">
                    <span [class]="riskClass(row)">{{ statusLabel(row) }}</span>
                  </td>
                  <td class="date-column">{{ row.created_on | date: 'medium' }}</td>
                  <td class="notes-column" [title]="row.notes || ''">{{ truncateToWords(row.notes) || '-' }}</td>
                </tr>
                <tr *ngIf="!recentResultsPaged.length && !loadingRecentResults" class="no-data-row">
                  <td colspan="6" class="no-data-cell text-center py-4">No captures yet.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <app-paginator
            *ngIf="recentResultsCount > recentResultsPerPage"
            [currentPage]="recentResultsCurrentPage"
            [totalItems]="recentResultsCount"
            [itemsPerPage]="recentResultsPerPage"
            (pageChange)="onRecentResultsPageChange($event)"
          ></app-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
